const RightIcon = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    t="1778914217901"
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="2545"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M326.7079 958.51045l-63.278185-60.523445L651.328255 512.841158 257.924327 124.944664l66.024739-60.523445 445.672362 448.419939L326.7079 958.51045z"
      fill={color}
      p-id="2546"
    ></path>
  </svg>
);

export default RightIcon;
